export default __webpack_public_path__ + "static/media/GooglePlay.99c123f6.svg";